export default ({payload, next}) => {
  const {
    obj: {messageId, properties = {}}
  } = payload

  if (messageId) {
    payload.obj.properties = {
      ...properties,
      messageId
    }
  }

  next(payload)
}
